import React from "react";

const EnvolvementThumbnailSkeleton = ({ cards }) => {
  return (
    <>
      {[...Array(cards)].map((_, index) => (
        <div
          key={index}
          className="group relative bg-white dark:bg-gray-800 rounded-2xl overflow-hidden shadow-lg animate-pulse"
        >
          {/* Image Container */}
          <div className="relative aspect-video overflow-hidden bg-gray-200 dark:bg-gray-700">
            {/* Price Badge Skeleton */}
            <div className="absolute top-4 right-4 w-16 h-7 bg-gray-300 dark:bg-gray-600 rounded-full" />
            {/* User Info Skeleton */}
            <div className="absolute bottom-4 left-4 flex items-center space-x-3">
              <div className="w-12 h-12 bg-gray-300 dark:bg-gray-600 rounded-full border-4 border-white dark:border-gray-800" />
              <div className="h-5 w-24 bg-gray-300 dark:bg-gray-600 rounded"></div>
            </div>
          </div>

          {/* Content Container */}
          <div className="p-5 space-y-4">
            {/* Title and Preview */}
            <div>
              <div className="h-6 w-3/4 bg-gray-200 dark:bg-gray-700 rounded" />
              <div className="mt-3 space-y-2">
                <div className="h-4 w-full bg-gray-200 dark:bg-gray-700 rounded" />
                <div className="h-4 w-5/6 bg-gray-200 dark:bg-gray-700 rounded" />
              </div>
            </div>

            {/* Categories Skeleton */}
            <div className="flex flex-wrap gap-2">
              <div className="h-6 w-20 bg-gray-200 dark:bg-gray-700 rounded-full" />
              <div className="h-6 w-24 bg-gray-200 dark:bg-gray-700 rounded-full" />
              <div className="h-6 w-16 bg-gray-200 dark:bg-gray-700 rounded-full" />
            </div>

            {/* Stats Container Skeleton */}
            <div className="flex items-center justify-between pt-3 border-t border-gray-200 dark:border-gray-700">
              <div className="flex items-center space-x-4">
                <div className="flex items-center space-x-1">
                  <div className="w-4 h-4 bg-gray-200 dark:bg-gray-700 rounded-full" />
                  <div className="h-4 w-20 bg-gray-200 dark:bg-gray-700 rounded" />
                </div>
                <div className="flex items-center space-x-1">
                  <div className="w-4 h-4 bg-gray-200 dark:bg-gray-700 rounded-full" />
                  <div className="h-4 w-16 bg-gray-200 dark:bg-gray-700 rounded" />
                </div>
              </div>
            </div>
          </div>
        </div>
      ))}
    </>
  );
};

export default EnvolvementThumbnailSkeleton;
